import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineInsertComment } from "react-icons/md";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const Information = ({
  bindField,
  initialValues,
  setPercent,
  isFieldRequired,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const INFORMATION = t(
    "SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.INFORMATION",
    {
      returnObjects: true,
    },
  );
  const DEFAULT_QUESTIONS = [
    "project.fields.info.cssBeneficiary",
    "project.fields.info.ccChiBeneficiary",
    "project.fields.info.protectionRegime",
    "project.contact.politicallyExposedPerson",
  ];

  const commentPath = "project.fields.info.comment";
  const commentField = bindField(commentPath, {
    label: INFORMATION.COMMENT,
    required: isFieldRequired(commentPath),
    onChange: () => setPercent(initialValues),
  });

  const buildSwitchField = (path, label) => {
    const field = bindField(path, {
      label,
      onChange: () => setPercent(initialValues),
    });
    return (
      <FormField
        key={path}
        path={field.path}
        label={field.label}
        required={field.required}
        disabled={field.disabled}
      >
        {(inputField) => (
          <Input
            type="switch"
            label={label}
            defaultChecked={get(initialValues, path)}
            {...inputField}
            onChange={field.onChange}
            onBlur={field.onBlur}
          />
        )}
      </FormField>
    );
  };

  const QUESTION_LABELS = {
    "project.fields.info.cssBeneficiary": INFORMATION.CSH_BENEFICIARY,
    "project.fields.info.participationCollectiveBeneficiary":
      INFORMATION.PARTICIPATION_COLLECTIVE_BENEFICIARY,
    "project.fields.info.ccChiBeneficiary": INFORMATION.CC_CHI_BENEFICIARY,
    "project.fields.info.protectionRegime": INFORMATION.PROTECTION_REGIME,
    "project.contact.politicallyExposedPerson":
      INFORMATION.POLITICALLY_EXPOSED_PERSON.LABEL,
    "project.fields.info.fonctionnaryOrAgent": INFORMATION.OFFICIAL_AGENT,
  };

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.INFORMATION}-section`}
    >
      <Form type="vertical" title={INFORMATION.TITLE}>
        <div className="grid--1">
          {get(
            initialValues,
            "insurancePlan.config.information",
            DEFAULT_QUESTIONS,
          )
            .filter((info) => info != null && QUESTION_LABELS[info])
            .map((info) => buildSwitchField(info, QUESTION_LABELS[info]))}
          <FormField
            path={commentField.path}
            label={commentField.label}
            required={commentField.required}
            disabled={commentField.disabled}
          >
            {(field) => (
              <Input
                type="textarea"
                label={commentField.label}
                placeholder={INFORMATION.COMMENT}
                icon={<MdOutlineInsertComment size={16} />}
                normalizeText={true}
                defaultValue={commentField.defaultValue}
                {...field}
                onChange={commentField.onChange}
                onBlur={commentField.onBlur}
                autoSize={{ minRows: 2, maxRows: 10 }}
                optional={!commentField.required}
              />
            )}
          </FormField>
        </div>
      </Form>
    </div>
  );
};

export default Information;
